import { Link } from "react-router-dom";
import { ShoppingCart, Download } from "lucide-react";

export default function BookCard({ book, testId }) {
  const links = book.purchase_links || [];
  const impreso = links.filter((l) => l.tipo !== "ebook");
  const ebook = book.ebook_directo ? [] : links.filter((l) => l.tipo === "ebook");
  const freeDownload = book.descarga_gratuita && book.archivo_descarga;

  const buyBtn = (list, label, variant) => {
    if (list.length === 0) return null;
    const single = list.length === 1 ? list[0].url : null;
    const cls =
      variant === "solid"
        ? "bg-[#0f2544] text-white hover:bg-[#1f44e0] border border-[#0f2544]"
        : "border border-[#0f2544]/30 text-[#0f2544] hover:bg-[#0f2544] hover:text-white";
    const common = `flex-1 min-w-0 inline-flex items-center justify-center gap-1 px-1.5 sm:px-2.5 py-2 text-[0.62rem] sm:text-[0.68rem] font-semibold tracking-normal sm:tracking-[0.07em] uppercase transition-colors ${cls}`;
    const testId = `buy-${variant === "solid" ? "impreso" : "ebook"}-${book.slug}`;
    return single ? (
      <a href={single} target="_blank" rel="noreferrer" className={common} data-testid={testId}>
        <ShoppingCart size={12} /> {label}
      </a>
    ) : (
      <Link to={`/libros/${book.slug}`} className={common} data-testid={testId}>
        <ShoppingCart size={12} /> {label}
      </Link>
    );
  };

  return (
    <div className="group hv-book-hover block" data-testid={testId || `book-card-${book.slug}`}>
      <Link to={`/libros/${book.slug}`} className="block">
        <div className="hv-book">
          {book.portada ? (
            <img src={book.portada} alt={`Portada de ${book.titulo}`} loading="lazy" />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-[#e7e5df] text-[#8a8a83] text-xs px-3 text-center">{book.titulo}</div>
          )}
        </div>
        <h3 className="font-serif text-base font-semibold text-[#0f2544] leading-snug mt-3 group-hover:text-[#1f44e0] transition-colors">{book.titulo}</h3>
        {book.autor_nombre && <p className="text-[0.8rem] text-[#8a8a83] mt-0.5">{book.autor_nombre}</p>}
      </Link>

      {(freeDownload || impreso.length > 0 || ebook.length > 0 || book.ebook_directo) && (
        <div className="flex gap-1 sm:gap-2 mt-3 min-w-0" data-testid={`book-buy-${book.slug}`}>
          {freeDownload ? (
            <a href={book.archivo_descarga} target="_blank" rel="noreferrer" className="flex-1 inline-flex items-center justify-center gap-1.5 px-2.5 py-2 text-[0.68rem] font-semibold tracking-[0.07em] uppercase bg-[#1f44e0] text-white hover:bg-[#0f2544] transition-colors" data-testid={`download-free-${book.slug}`}>
              <Download size={12} /> Descargar
            </a>
          ) : (
            <>
              {buyBtn(impreso, "Impreso", "solid")}
              {book.ebook_directo ? (
                <Link to={`/libros/${book.slug}#comprar-ebook`} className="flex-1 min-w-0 inline-flex items-center justify-center gap-1 px-1.5 sm:px-2.5 py-2 text-[0.62rem] sm:text-[0.68rem] font-semibold tracking-normal sm:tracking-[0.07em] uppercase transition-colors border border-[#0f2544]/30 text-[#0f2544] hover:bg-[#0f2544] hover:text-white" data-testid={`buy-ebook-${book.slug}`}>
                  <ShoppingCart size={12} /> Ebook
                </Link>
              ) : buyBtn(ebook, "Ebook", "outline")}
            </>
          )}
        </div>
      )}
    </div>
  );
}
